var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardTotalDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 3.3125C8.9 4.05842 8.61554 4.77379 8.10919 5.30124C7.60284 5.82868 6.91608 6.125 6.2 6.125C5.48392 6.125 4.79716 5.82868 4.29081 5.30124C3.78446 4.77379 3.5 4.05842 3.5 3.3125C3.5 1.75875 4.7084 0.5 6.2 0.5C7.6916 0.5 8.9 1.75875 8.9 3.3125ZM0.5 10.7081C0.5 8.49188 4.298 7.375 6.2 7.375C8.102 7.375 11.9 8.49188 11.9 10.7081V15.5H0.5V10.7081ZM21.5 3.3125C21.5 4.05842 21.2155 4.77379 20.7092 5.30124C20.2028 5.82868 19.5161 6.125 18.8 6.125C18.0839 6.125 17.3972 5.82868 16.8908 5.30124C16.3845 4.77379 16.1 4.05842 16.1 3.3125C16.1 1.75875 17.3084 0.5 18.8 0.5C20.2916 0.5 21.5 1.75875 21.5 3.3125ZM14.3 2.375C14.3 2.87228 14.1104 3.34919 13.7728 3.70083C13.4352 4.05246 12.9774 4.25 12.5 4.25C12.0226 4.25 11.5648 4.05246 11.2272 3.70083C10.8896 3.34919 10.7 2.87228 10.7 2.375C10.7 1.87772 10.8896 1.40081 11.2272 1.04917C11.5648 0.697544 12.0226 0.5 12.5 0.5C12.9774 0.5 13.4352 0.697544 13.7728 1.04917C14.1104 1.40081 14.3 1.87772 14.3 2.375ZM13.1 10.7081C13.1 8.49188 16.898 7.375 18.8 7.375C20.702 7.375 24.5 8.49188 24.5 10.7081V15.5H13.1V10.7081Z",
    fill: "#115E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTotalDonation);
export default __webpack_public_path__ + "static/media/CardTotalDonation.c11620e1a3fa63ff3c2858e46e8ebb78.svg";
export { ForwardRef as ReactComponent };